import React from 'react';
import Router, { useRouter } from 'next/router';
import SettingsMenu from '@/components/settings/menu';
import { createFileRoute } from '@tanstack/react-router'
import EditTemplateV2 from "@/PageComponents/Settings/Template/EditTemplateV2";

function TemplateEdit() {

  const router = useRouter();
  const { name, module, templateType } = router.query;
 // TODO(tanstack-router): verify router.query → useParams/useSearch

  let currPath = '';
  if (Router.router) {
    currPath = Router.router.asPath;
  }

  const template = {
    Name: name,
    Module: module,
    TemplateType: templateType,
  };

  if (!router.isReady) return null;

  return (
    <div className="settings-container">
      {/*<div className="row">
        <div className="title">
          <Breadcrumbs
            crumbs={[
              { text: 'Settings', link: '', suppressLink: true },
              { text: 'Templates', link: '/settings/template/list' },
              { text: `${props.template.Name}`, link: '' },
            ]}
          />
        </div>
        <div className="actions">

        </div>
      </div>*/}
      <div className="row">
        <SettingsMenu urlPath={currPath} />
        <div className="settings-card">

          <EditTemplateV2 template={template} fromCreate={true} fromExternalModule={false} />

        </div>
      </div>

      <style jsx>{`
        .row {
          display: flex;
        }
        .column {
          display: flex;
          flex-basis: 0;
          flex-direction: column;
          flex-grow: 1;
        }
        .column :global(.textarea-container) {
          height: 100%;
        }
        .column + .column {
          margin-left: 1.25rem;
        }
        .column-end {
          align-items: flex-end;
        }
        .image-button {
          cursor: pointer;
        }
        .joditContainer {
          position: relative;
        }
        .note {
          margin-top: 1rem;
        }
        .tagSelector {
          position: absolute;
          right: 1rem;
          top: 3rem;
        }
        .tagSelectorNoToolbar {
          position: absolute;
          right: 1rem;
          top: 1rem;
        }
        .actions {
          display: flex;
        }
        .actions :global(.button){
          margin-left: 0.5rem;
          margin-top: 0;
          padding: 0 1rem;
          white-space: nowrap;
        }

      `}</style>
    </div>
  );
}

export default TemplateEdit;

export const Route = createFileRoute('/_authenticated/settings/template/edit')({ component: TemplateEdit })
